// El QR del gafete contiene JSON {"folio":"CF0003","nombre":"..."} (LabelPrinter.tsx) y el
// lector de códigos lo "teclea" completo en la búsqueda. Si el término trae un folio
// etiquetado así, se busca solo por el folio; cualquier otro término se deja igual.
export function extractFolioFromScan(term: string): string {
  const trimmed = term.trim()
  if (!/folio/i.test(trimmed)) return term

  try {
    const data = JSON.parse(trimmed)
    if (data && typeof data === "object" && data.folio) return String(data.folio).trim()
  } catch {
    // JSON incompleto o con símbolos cambiados por la distribución del teclado del lector
  }

  // "folio":"CF0003", folio=CF0003, ¨folio¨Ñ¨CF0003¨, folioCF0003…
  const match = trimmed.match(/folio[^A-Za-z0-9]*([A-Za-z]{2,}\d+)/i)
  return match ? match[1].toUpperCase() : term
}
